import { apiSlice } from "../../../../app/apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["Trait", "Behavior", "Classroom"],
});

const traitsApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getTrait: builder.query({
      query: (parameter) => `/trait/${parameter}`,
      providesTags: ["Trait"],
    }),
    getBehavior: builder.query({
      query: (parameter) => `/trait/behavior/${parameter}`,
      providesTags: ["Behavior"],
    }),
    createTrait: builder.mutation({
      query: (values) => ({
        url: "/trait/create",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Trait"],
    }),
    createBehavior: builder.mutation({
      query: (values) => ({
        url: "/trait/behavior/create",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Trait"],
    }),
    updateTrait: builder.mutation({
      query: (values) => ({
        url: "/trait/update",
        method: "PUT",
        body: { ...values },
      }),
      invalidatesTags: ["Trait"],
    }),
    updateBehavior: builder.mutation({
      query: (values) => ({
        url: "/trait/behavior/update",
        method: "PUT",
        body: { ...values },
      }),
      invalidatesTags: ["Behavior", "Trait"],
    }),
    deleteTrait: builder.mutation({
      query: (values) => ({
        url: `/trait/${values.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Trait"],
    }),
    deleteBehavior: builder.mutation({
      query: (values) => ({
        url: `/trait/behavior/${values.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Trait"],
    }),
    copyTrait: builder.mutation({
      query: ({ id, subsection_id }) => ({
        url: `/trait/${id}/copy`,
        method: "POST",
        body: { subsection_id },
      }),
      invalidatesTags: ["Trait"],
    }),
    copySubsectionTraits: builder.mutation({
      query: ({ source_subsection_id, target_subsection_id }) => ({
        url: `/trait/copy-subsection`,
        method: "POST",
        body: { source_subsection_id, target_subsection_id },
      }),
      invalidatesTags: ["Trait"],
    }),
    getClassroomsPaginated: builder.query({
      query: ({ page = 1, per_page = 20, q = "" } = {}) =>
        `/classroom/all?page=${page}&per_page=${per_page}&q=${encodeURIComponent(q)}`,
      providesTags: ["Classroom"],
    }),
    getTraitsForClassroom: builder.query({
      query: (classroom_id) => `/trait/for-classroom/${classroom_id}`,
      providesTags: ["Trait"],
    }),
  }),
});

export const {
  useGetTraitQuery,
  useGetBehaviorQuery,
  useCreateTraitMutation,
  useCreateBehaviorMutation,
  useUpdateTraitMutation,
  useUpdateBehaviorMutation,
  useDeleteTraitMutation,
  useDeleteBehaviorMutation,
  useCopyTraitMutation,
  useCopySubsectionTraitsMutation,
  useGetClassroomsPaginatedQuery,
  useGetTraitsForClassroomQuery,
} = traitsApiSlice;
